import { CardTypes } from "./index";
export enum AnalyticEvents {
  VIEWED = "Viewed",
  VIEWABLE = "Viewable",
  CLICKED_THROUGH = "Clicked-through",
  ERROR = "Error",
  INTERACTED = "Interacted",
  IMPRESSION = "Impression"
}

export interface Pixels {
  impression: string;
  clickThrough: string;
}

export interface AnalyticsContext {
  viewID: string;
  emit: boolean;
  pixels: Pixels;
  statsURL: string;
  catalogueID: string;
  pageUrl: string;
  operator?: string;
  customField: CustomField;
  adtagID: string;
  campaignID?: string;
  brandID: string;
  externalID?: string;
  campaignVariantIndex?: string;
  offerDisplayedAsFallback: boolean;
  defaultOfferDisplayedAsFirstCard: boolean;
  marketInsightsCardIncluded: boolean;
  parlayIncluded: boolean;
  experimentID?: string;
  experimentVariant?: string;
  recommenderBehaviour: string;
}

export interface CardAnalyticsContext {
  viewID: string;
  emit: boolean;
  enabled: boolean;
  statsURL: string;
  catalogueID: string;
  pageUrl: string;
  operator?: string;
  customField: CustomField;
  adtagID: string;
  brandID: string;
  campaignID?: string;
  experimentID?: string;
  experimentVariant?: string;
  experimentType?: string;
  recommenderBehaviour: string;
  recommenderDetail: string;
}

export interface CardsContext {
  cards: Card[];
}

export interface Card {
  type: CardTypes;
  sport: string;
  competition: string;
  betType: string;
  srTournamentID?: string;
  srHomeID?: string;
  srAwayID?: string;
  srMatchID?: string;
  eventName?: string;
}

export interface AnalyticsBet {
  betOptionID?: string;
  betID: string;
}

export interface CustomField {
  customField1?: string | null;
  customField2?: string | null;
  customField3?: string | null;
  customField4?: string | null;
  customField5?: string | null;
}

export interface AnalyticsRequest {
  adtagID: string;
  brandID: string;
  campaignID?: string;
  bets: AnalyticsBet[];
  viewID: string;
  externalID?: string;
  version: string;
  operator: string;
  statsEventName: string;
  statsEventDescription: string;
  adScreenHeight: number;
  adScreenWidth: number;
  catalogueID: string;
  stakeCurrency?: string;
  stakeAmount?: number;
  pageUrl: string;
  campaignVariantIndex?: string;
  customField1?: string;
  customField2?: string;
  customField3?: string;
  customField4?: string;
  customField5?: string;
  offerDisplayedAsFallback: boolean;
  defaultOfferDisplayedAsFirstCard: boolean;
  prerollDisplayed: boolean;
  prerollName?: string;
  marketInsightsCardIncluded: boolean;
  parlayIncluded: boolean;
  experimentID?: string;
  experimentVariant?: string;
  recommenderBehaviour: string;
}

export interface CardAnalyticsRequest {
  adtagID: string;
  brandID: string;
  campaignID?: string;
  viewID: string;
  operator: string;
  recommenderBehaviour: string;
  recommenderDetail: string;
  statsEventName: string;
  statsEventDescription: string;
  statsEventCard: string;
  statsEventOptionName: string;
  adScreenHeight: number;
  adScreenWidth: number;
  catalogueID: string;
  pageUrl: string;
  customField1?: string;
  customField2?: string;
  customField3?: string;
  customField4?: string;
  customField5?: string;
  experimentID?: string;
  experimentVariant?: string;
  experimentType?: string;
  card1?: Card | undefined;
  card2?: Card | undefined;
  card3?: Card | undefined;
  card4?: Card | undefined;
  card5?: Card | undefined;
  cardCount?: number;
}
